import axios from 'axios'
import { parseUrl, stringify } from 'query-string'
import { getGNBMultiBannerEventListByUICode, mapPathToUICode } from '@/common/util/menu.util'
import EventModelClass from '@/common/model/EventModelClass'
import { ERROR_FROM_PROGRAM_LOGIC } from '@/common/message.const'
import {
  API_BASE_URL_CLOVER_FIELD,
  API_KEY,
  SORT_BY_NEWER,
  URL_COOKIE_DOMAIN,
  URL_PROTOCOL_DOMAIN,
  API_BASE_URL,
  API_BASE_URL_FROZEN
} from '@/common/constant'
import { MENU_LIVE, MENU_MOVIE, MENU_TV_CUT, MENU_VOD } from '@/common/menu/menu.const'
import { get, first } from 'lodash'
import utils from '@/common/util/utils'
import { eventBodyListParser } from '@/common/util/event.util'
import { getDomainWithPrefix, getDomainWithWordPrefix, setServiceLocationInfo } from '@/common/util/common'
import { DEVICE_TYPE_ANDROID, DEVICE_TYPE_MOBILE } from '@/common/devicetype.const'

/**
 * TODO::현재 API 공통 로직이 api.service, request.common(pc소스 기반 가져온 것) 두군데 있음
 * 정리하여 한곳으로 통합 필요
 * 가능하면 최신화가 잘되고 있는 pc기반 utils/ 를 사용
 * 기존 코드에서 util/ -> utils/ 로 바꾸고
 * 향후 private npm을 사용할 기반 준비할 필요가 있음
 */

export const HTTP_METHOD_GET = 'get'
export const HTTP_METHOD_POST = 'post'
export const HTTP_METHOD_DELETE = 'delete'
export const HTTP_METHOD_DEEP_LINK = 'deeplink'

const QASerive = {
  changeDeviceType ({ type }) {
    let expires = new Date()
    expires.setHours(0, 0, 0, 0)
    expires.setDate(expires.getDate() + 365)
    utils.cookies.setItem('qa-device-type', type, expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
  },
  toggleWaterMark (isShow) {
    let expires = new Date()
    expires.setHours(0, 0, 0, 0)
    expires.setDate(expires.getDate() + 365)
    utils.cookies.setItem('qa-water-mark', String(isShow), expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
  },
  getCurrentDeviceType () {
    return utils.cookies.getItem('qa-device-type') || 'mobile'
  },
  getToggleMarkShow () {
    return utils.cookies.getItem('qa-water-mark') || 'false'
  }
}
const getCommonParam = () => {
  // 동적으로 변환할것은 vuex state에서 변환
  return {
    apikey: API_KEY,
    device: utils.cookies.getDevice(), // 추천밴드 콘텐츠전시
    partner: 'pooq',
    pooqzone: utils.cookies.getDevice() === 'mobile' ? 'none' : utils.cookies.getPooqZone(),
    region: 'kor',
    drm: utils.cookies.getDrm(),
    targetage: utils.cookies.getTargetAge(),
    service: 'wavve',
    client_version: '6.1.0'
  }
}

const getCredential = (key) => {
  return {
    [key]: utils.cookies.getCredential()
  }
}

const commonErrorProcess = (error) => {
  if (error.response && error.response.status === 550) {
    let message = error.response.data.resultmessage ? error.response.data.resultmessage
      : '서버에서 알 수 없는 오류가 발생했습니다.'
    utils.alert(message.replace('\\\\n', '\n').replace('\\n', '\n'))
  }
}

const GNBService = {
  setMultiBannerListByMenuName: (menuName) => {
    const uiCode = mapPathToUICode(menuName)
    const { onContentEvent } = getGNBMultiBannerEventListByUICode(uiCode)
    return EventService.requestEventData(new EventModelClass(onContentEvent)).then((res) => {
      return res.data
    }).catch(commonErrorProcess)
  }
}

export const commonRequestInstanceToAxiosRequestInfo = (instance) => {
  const requestInfo = {
    url: instance.url,
    method: instance.method,
    responseType: 'json',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json; charset=utf-8'
    } }
  // INFO: Support Azure migration
  // INFO : for test
  // function appendApiList (url) {
  //   testArr.push(url)
  //   if (testArr.length > 6) {
  //     testArr.shift()
  //   }
  //   const apiListDiv = document.querySelector('#call-api-list')
  //   if (apiListDiv) {
  //     apiListDiv.innerHTML = testArr.map((pUrl) => {
  //       const { url } = parseUrl(pUrl)
  //       return `<div style="color:${locationType === SERVICE_LOCATION_AZURE ? 'yellow' : 'white'};font-size: 12px;font-weight: bold">${url}</div>`
  //     }).join('')
  //   }
  // }

  // if (locationType === SERVICE_LOCATION_AZURE && !forceAWS) {
  //   requestInfo.url = requestInfo.url.replace(API_BASE_URL, API_BASE_AZURE_URL)
  //   // console.log('%c AZURE CALL : %s', 'font-size: 12px;color: green', requestInfo.url)
  // }
  // else {
  //   console.log('%c AWS CALL : ', 'font-size:12px;color:red', requestInfo.url)
  //   if (forceAWS) {
  //     console.log('%c FORCE AWS CALL', 'font-size:13px;color:yellow')
  //   }
  // }
  // appendApiList(requestInfo.url)

  if (instance.headers) {
    requestInfo.headers = instance.headers
  }
  if (instance.needCommonParams) {
    requestInfo.params = getCommonParam()
  }
  if (instance.needCredential) {
    requestInfo.headers = Object.assign({}, requestInfo.headers, getCredential('wavve-credential'))
  }
  requestInfo.paramsSerializer = (params) => {
    return stringify(params, { encode: false })
  }
  if (instance.method === HTTP_METHOD_POST || instance.method === HTTP_METHOD_DELETE) {
    requestInfo.data = instance.data
    requestInfo.transformRequest = (data, headers) => {
      return JSON.stringify(data)
    }
  }
  if (instance.requestId) {
    requestInfo.requestId = instance.requestId
  }
  return requestInfo
}

export const applyQueryString = (url, queryString) => `${url}?${stringify(queryString)}`
export const applyPath = (url, path) => `${url}/${path}`

export const apiRequest = (convertedApiRequest, catchFn) => {
  const catchProcess = typeof catchFn === 'function' ? catchFn : commonErrorProcess
  return axios(convertedApiRequest).catch(catchProcess)
}

export const apiRequestWithoutCatchFn = (convertedAPiRequest) => {
  return axios(convertedAPiRequest)
}

const EventService = {
  convertEventModelInstanceToAxiosRequestInfo (eventInstance) {
    if (!(eventInstance instanceof EventModelClass)) {
      throw ERROR_FROM_PROGRAM_LOGIC
    }
    return commonRequestInstanceToAxiosRequestInfo(eventInstance)
  },
  requestEventData (eventInstance, catchFn) {
    return apiRequest(this.convertEventModelInstanceToAxiosRequestInfo(eventInstance), catchFn)
  },
  getEvents ({ status, offset, limit }) {
    const URL = `${API_BASE_URL}/events?status=${status}&offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getEventDetail ({ eventid }) {
    const URL = `${API_BASE_URL}/events/${eventid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getEventDetailContent ({ eventid, offset, limit, contentType = '' }) {
    const URL = `${API_BASE_URL}/events-contents/${eventid}?offset=${offset}&limit=${limit}&contenttype=${contentType}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getEventNotice ({ offset, limit }) {
    const URL = `${API_BASE_URL}/events-notice?offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getEventNoticeContent ({ eventid }) {
    const URL = `${API_BASE_URL}/events-notice/${eventid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const DeepLinkService = {
  getUrlFromUiCode: (uiCode) => {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/deeplink/${uiCode}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    })).then(({ data }) => {
      return data
    })
  }
}

const getCommonEventModelInstance = (url) => {
  const eventModelInstance = new EventModelClass()
  eventModelInstance.method = HTTP_METHOD_GET
  eventModelInstance.needCommonParams = true
  eventModelInstance.needCredential = true
  eventModelInstance.url = url
  return eventModelInstance
}

const VodInfoService = {
  /**
   * VOD 랜딩 인포 API
   * @param programID
   * @param contentID
   * @param history
   * @returns {Promise<AxiosResponse<any>>}
   */
  getContentLandingInfo: ({ programID = '', contentID = '', history = 'all' }) => {
    const params = contentID
      ? `contentid=${contentID}`
      : `programid=${programID}&history=${history}`
    const URL = `${API_BASE_URL_FROZEN}/vod/programs/landing?${params}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
    // return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    //   url: URL,
    //   method: HTTP_METHOD_GET,
    //   needCommonParams: true,
    //   needCredential: true
    // }))
  },
  /**
   * VOD 상세 API
   * @param contentID
   * @returns {Promise<AxiosResponse<any>>}
   */
  getVodMetaInfo: ({ contentID }) => {
    // const URL = `${API_BASE_URL_CLOVER_FIELD}/vod/contents/${contentID}?`
    // const URL = `${API_BASE_URL_FROZEN}/vod/contents/${contentID}?`
    const timeStamp = new Date().getTime()
    const URL = `${API_BASE_URL_FROZEN}/vod/contents-detail/${contentID}?timestamp=${timeStamp}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getRecommendMultiSection: ({ programID, contentID }) => {
    const URL = `${API_BASE_URL}/v1/multiband/DN1?contentid=${contentID}&programid=${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getEventBanner: ({ programID }) => { // common
    const URL = `${API_BASE_URL_CLOVER_FIELD}/events-banner/contents/${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  /**
   * VOD 에피소드 목록 API 호출
   * @param programID
   * @param offset
   * @param limit
   * @param orderBy
   * @param genre
   * @param path langing api에서 episode path값이 있다면 우선 적용 (orderby는 제외)
   * @returns {Promise<AxiosResponse<any>>}
   */
  getAllContentList: ({ programID, offset = 0, limit = 20, orderBy = SORT_BY_NEWER, genre = '', path = '' }) => {
    let URL = ''
    if (path && path !== '') {
      const parsePath = parseUrl(path)
      parsePath.query['orderby'] = orderBy
      URL = `${API_BASE_URL}${parsePath.url}?${stringify(parsePath.query)}`
    } else {
      URL = `${API_BASE_URL_FROZEN}/vod/programs/${programID}/contents?orderby=${orderBy}`
    }
    // const URL = `${API_BASE_URL_FROZEN}/vod/programs-contents/${programID}?orderby=${orderBy}`
    // const URL = `${API_BASE_URL_CLOVER_FIELD}/vod/programs-contents/${programID}?orderby=${orderBy}`
    const eventInstance = getCommonEventModelInstance(URL)
    eventInstance.setPaging(true)
    eventInstance.offset = offset
    eventInstance.limit = limit
    return EventService.requestEventData(eventInstance)
  },
  // getZzimInfo: (contentID) => {
  //   const URL = `${API_BASE_URL}/zzim/contents/${contentID}`
  //   return EventService.requestEventData(getCommonEventModelInstance(URL))
  // },
  getContentIdByProgramId: ({ programID }) => {
    const URL = `${API_BASE_URL}/vod/programs-contentid/${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getContentIdByProgramIdWithCatchFn: ({ programID }, catchFn) => {
    const URL = `${API_BASE_URL}/vod/programs-contentid/${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL), catchFn)
  },
  getContentNoticeInfo: ({ programID }) => {
    const URL = `${API_BASE_URL}/es/notice/contents/${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getVodRelatedContents: ({ programid, offset, limit, path = '' }) => {
    let URL = ''
    if (path && path !== '') {
      URL = `${API_BASE_URL}${path}?offset=${offset}&limit=${limit}`
    } else {
      URL = `${API_BASE_URL_FROZEN}/vod/programs/${programid}/contents/related?offset=${offset}&limit=${limit}`
    }
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  }
}

const LiveInfoService = {
  getLiveMetaInfo: ({ channelID }) => {
    const URL = `${API_BASE_URL}/live/channels/${channelID}?channelid=${channelID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getAllContentList: ({ offset = 0, limit = 200, orderBy = SORT_BY_NEWER, genre }) => {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/live/recommend-channels?isrecommend=n&contenttype=channel&WeekDay=all&offset=0&limit=200&genre=${genre}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getRecommendMultiSection: ({ channelID }) => {
    const URL = `${API_BASE_URL}/v1/multiband/DY1?channelid=${channelID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getAlarms: ({ alarmtype, contentid, programid, releasedatetime }, catchFn) => {
    const URL = `${API_BASE_URL}/alarms-contents-regist`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        contentid,
        programid,
        releasedatetime
      }
    }), catchFn)
  },
  deleteAlarms: ({ alarmtype, contentid, releasedatetime }) => {
    const URL = `${API_BASE_URL}/alarms-contents`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        contentid,
        releasedatetime
      }
    }))
  },
  // getZzimInfo: ({ channelID }) => {
  //   const URL = `${API_BASE_URL}/zzim/contents/${channelID}?contentid=${channelID}&contenttype=live&limit=100&offset=0`
  //   return EventService.requestEventData(getCommonEventModelInstance(URL))
  // },
  getEpgs ({ channelid, startdatetime, enddatetime, offset = 0, limit = 20, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/live/epgs/channels/${channelid}?startdatetime=${startdatetime}` +
      `&enddatetime=${enddatetime}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getLiveEpgsChannels ({ startdatetime, enddatetime, offset, limit, orderby }) {
    const URL = `${API_BASE_URL}/live/epgs/channels?startdatetime=${startdatetime}&enddatetime=${enddatetime}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getContentIdByProgramId: ({ programID }, catchFn) => {
    const URL = `${API_BASE_URL}/vod/programs-contentid/${programID}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }), catchFn)
  }
}

const MovieInfoService = {
  getMovieMetaInfo: ({ movieID }, catchFn) => {
    // const URL = `${API_BASE_URL_CLOVER_FIELD}/movie/contents/${movieID}`
    const URL = `${API_BASE_URL_FROZEN}/movie/contents/${movieID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL), catchFn)
  },
  getRecommendMultiSection: ({ movieID }) => {
    const URL = `${API_BASE_URL}/v1/multiband/DN2?movieid=${movieID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getEventBanner: ({ movieID }) => { // common
    const URL = `${API_BASE_URL_CLOVER_FIELD}/events-banner/contents/${movieID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getContentNoticeInfo: ({ movieId }) => {
    const URL = `${API_BASE_URL}/es/notice/contents/${movieId}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getSeriesContentList: ({ movieID }) => {
    const URL = `${API_BASE_URL_FROZEN}/movie/series/contents/${movieID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getMovieSeriesContents: ({ movieid = '' }) => {
    const URL = `${API_BASE_URL_FROZEN}/movie/series//${movieid}/contents`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getMovieRelatedContents: ({ movieid, offset, limit }) => {
    const URL = `${API_BASE_URL_FROZEN}/movie/related/${movieid}/contents?offset=${offset}&limit=${limit}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  }
  // getZzimInfo: ({ contentID }) => {
  //   const URL = `${API_BASE_URL}/zzim/contents/${contentID}`
  //   return EventService.requestEventData(getCommonEventModelInstance(URL))
  // }
}

const ClipInfoService = {
  getClipMetaInfo: ({ clipID }) => {
    const URL = `${API_BASE_URL}/clip/contents/${clipID}?clipid=${clipID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getRecommendMultiSection: ({ clipID }) => {
    const URL = `${API_BASE_URL}/v1/multiband/DN4?clipid=${clipID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getAllContentList: ({ contentID = '', programID = '', offset = 0, limit = 20, orderBy = SORT_BY_NEWER }) => {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/clip/contents?channel=all&contentid=${contentID}&programid=${programID}&offset=${offset}&limit=${limit}&orderby=${orderBy}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  },
  getPooqContentId: ({ programID }) => {
    const URL = `${API_BASE_URL}/vod/programs-contentid/${programID}?programid=${programID}`
    return EventService.requestEventData(getCommonEventModelInstance(URL))
  }
}

const BottomTabService = {
  getContentAllApi: (section) => {
    let api = null
    switch (section) {
      case MENU_VOD:
        api = VodInfoService.getAllContentList
        break
      case MENU_LIVE:
        api = LiveInfoService.getAllContentList
        break
      case MENU_MOVIE:
        api = null
        // api = MovieInfoService.getSeriesContentList
        break
      case MENU_TV_CUT:
        api = ClipInfoService.getAllContentList
        break
      default:
        api = null
    }
    return api
  },
  getRecommendMultiSectionListApi (section) {
    let api = null
    switch (section) {
      case MENU_VOD:
        api = VodInfoService.getRecommendMultiSection
        break
      case MENU_LIVE:
        api = LiveInfoService.getRecommendMultiSection
        break
      case MENU_MOVIE:
        api = MovieInfoService.getRecommendMultiSection
        break
      case MENU_TV_CUT:
        api = ClipInfoService.getRecommendMultiSection
        break
      default:
        api = null
    }
    return api
  },
  purchaseProducts ({ cpid, channelid, programid, contentid, contenttype, vouchertype, isplayy = 'n', recommendvoucher = 'none' }) {
    const URL = `${API_BASE_URL}/cf/purchase/products?cpid=${cpid}&channelid=${channelid}&programid=${programid}&contentid=${contentid}&contenttype=${contenttype}&vouchertype=${vouchertype}&isplayy=${isplayy}&recommendvoucher=${recommendvoucher}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  purchaseProductsNew ({ cpid, channelid, programid, contentid, contenttype, vouchertype, isplayy = 'n', downloadyn = 'N' }) {
    const URL = `${API_BASE_URL}/cf/purchase/newproducts?cpid=${cpid}&channelid=${channelid}&programid=${programid}&contentid=${contentid}&contenttype=${contenttype}&vouchertype=${vouchertype}&isplayy=${isplayy}&downloadyn=${downloadyn}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  purchaseProductContents ({ productid, contenttype, offset, limit }) {
    const URL = `${API_BASE_URL}/purchase/product-contents/${productid}?contenttype=${contenttype}&offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }

}

const getLoginRequestObject = ({ type = '', id = '', password = '', pushid = '', profile = '0', credential = '' }) => {
  // 그냥 로그인
  const URL = `${API_BASE_URL}/login`
  let resultObj = {}
  if (credential === '' || credential === 'none') {
    resultObj = { url: URL, needCommonParams: true, method: 'post', data: { type, id, pushid, password, profile } }
  } else { // 프로필 변경
    resultObj = {
      url: URL,
      needCommonParams: true,
      needCredential: true,
      method: HTTP_METHOD_POST,
      data: {
        type: 'credential',
        profile: String(profile),
        pushid,
        password,
        id: credential
      }
    }
  }
  return resultObj
}

const CommonService = {
  pooqzoneCheck () {
    const URL = `${API_BASE_URL}/pooqzone`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const UserService = {
  getPassList (uno) {
    const URL = `${API_BASE_URL}/cf/authentication/rights35/myProduct/pass/${uno}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getSktToken: ({ promotionCode = '' }) => {
    let callbackUrl = URL_PROTOCOL_DOMAIN + '/tcallback.html'
    callbackUrl = promotionCode !== '' ? callbackUrl + '?state=' + encodeURIComponent('promotioncode=' + promotionCode) : callbackUrl
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: 'https://apis.wavve.com/user/tid/auth?callback=' + callbackUrl +
        '&logoutcallback=' + callbackUrl,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  login: async ({ type, id, pushid = '', password, profile, credential = '' }, catchFn) => {
    const response = await apiRequest(commonRequestInstanceToAxiosRequestInfo(getLoginRequestObject({
      type,
      id,
      pushid,
      password,
      profile: String(profile),
      credential
    })), catchFn)

    const userCredential = get(response, ['data', 'credential'], 'none')
    const serviceLocation = await getServiceLocation(userCredential)
    const locationInfo = get(serviceLocation, ['data'], false)
    if (locationInfo) {
      setServiceLocationInfo(locationInfo)
    }
    return response
  },
  logout: ({ pushid = '' }) => {
    const URL = `${API_BASE_URL}/logout`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo(
      {
        url: URL,
        needCommonParams: true,
        needCredential: true,
        method: HTTP_METHOD_POST,
        data: {
          pushid: pushid
        }
      }
    ))
  },
  pooqzoneLogin ({ pooqzoneid, pincode }) {
    const URL = `${API_BASE_URL}/pooqzone/login`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        pooqzoneid,
        pincode
      }
    }))
  },
  userInfo: () => {
    const URL = `${API_BASE_URL}/user`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      needCommonParams: true,
      needCredential: true,
      method: HTTP_METHOD_GET
    }))
  },
  profiles: ({ offset = 0, limit = 20, orderby = 'new', credential }) => {
    const URL = `${API_BASE_URL}/es/profiles?offset=${offset}&limit=${limit}&orderby=${orderby}&credential=${encodeURIComponent(credential)}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      needCommonParams: true,
      // needCredential: true,
      method: HTTP_METHOD_GET
    }))
  },
  userPurchaseProducts: ({ productType, autoPayment, offset = 0, limit = 10, orderBy = 'new' }) => {
    const URL = `${API_BASE_URL}/mypurchase/products`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
      producttype: productType,
      autopayment: autoPayment,
      offset: offset,
      limit: limit,
      orderby: orderBy
    }))
  },
  // getUserOneOfProfile: ({ profileId = 0 }) => {
  //   const URL = `${API_BASE_URL}/es/profiles/${profileId}`
  //   return apiRequest(commonRequestInstanceToAxiosRequestInfo({
  //     url: URL,
  //     method: HTTP_METHOD_GET,
  //     needCommonParams: true,
  //     needCredential: true
  //   }))
  // },
  updateUserOneOfProfile: ({ profileId, imageId = 0, profileName = '', credential }) => {
    const URL = `${API_BASE_URL}/es/profiles/${profileId}?credential=${encodeURIComponent(credential)}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      // needCredential: true,
      needCommonParams: true,
      data: {
        imageid: imageId,
        profilename: profileName
      }
    }))
  },
  getUserProfileImageList: ({ offset = 0, limit = 30, orderBy = 'new' }) => {
    const URL = `${API_BASE_URL}/es/profiles-images?orderby=${orderBy}&offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCredential: true,
      needCommonParams: true
    }))
  },
  getUserSummary () {
    const URL = `${API_BASE_URL}/my/summary`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCredential: true,
      needCommonParams: true
    }))
  },
  getAlarmsNewCount () {
    const URL = `${API_BASE_URL}/alarms-new`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCredential: true,
      needCommonParams: true
    }))
  },
  getPermissionForContent ({ contentId, contentType }) {
    const URL = `${API_BASE_URL}/getpermissionforcontent?contentid=${contentId}&contenttype=${contentType}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCredential: true,
      needCommonParams: true
    }))
  },
  getProfileDetailInfo (profileId, credential) {
    const URL = `${API_BASE_URL}/es/profiles/${profileId}?credential=${encodeURIComponent(credential)}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      // needCredential: true,
      needCommonParams: true
    }))
  }
}

const SearchService = {
  getRecommendSearchKeywordList () {
    const URL = `${API_BASE_URL_FROZEN}/search/recommend/searchkeywords`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  },
  getCategoryList ({ type = 'vodgenre' }) {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/filters?type=${type}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  },
  getTagList ({ type = 'vodsearch' }) {
    const URL = `${API_BASE_URL}/tags/groups?type=${type}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  },
  tagAllSearch ({ limit = '20', offset = '20', orderby = 'score', type = 'all', searchtags, version = '2' }) {
    const URL = `${API_BASE_URL_FROZEN}/tagsearch?orderby=${orderby}&limit=${limit}&offset=${offset}&type=${type}&selectparam=url&version=${version}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        searchtags
      }
    }))
  },
  tagSearch ({ limit = '20', offset = '0', orderby = 'score', type = 'all', searchtags, mtype = '' }) {
    const URL = `${API_BASE_URL_FROZEN}/tagsearch/list.js?orderby=${orderby}&limit=${limit}&offset=${offset}&type=${type}&mtype=${mtype}&selectparam=url`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        searchtags
      }
    }))
  },
  tagSearchBand ({ url, searchtags }) {
    const URL = url
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        searchtags
      }
    }))
  },
  getRecommendKeywordByUserInput ({ keyword = '' }) {
    const catchFn = () => {
    }
    const URL = `${API_BASE_URL_FROZEN}/search/instance/keywords?${stringify({ keyword })}&type=all`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }), catchFn)
  },
  keywordSearch ({ limit = '20', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '' }) {
    const catchFn = () => {
    }
    const URL = `${API_BASE_URL}/search?${stringify({ keyword, type, offset, limit, orderby })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
      requestId: requestId
    }), catchFn)
  },
  keywordSearchCF ({ limit = '5', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '', mtype = '', version = '2' }) {
    if (requestId !== '') {
      axios.cancel(requestId)
    }
    const URL = `${API_BASE_URL_FROZEN}/search?${stringify({ keyword, type, offset, limit, orderby, mtype, version })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
      requestId: requestId
    }))
  },
  keywordSearchList ({ limit = '20', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '', mtype = '' }) {
    if (requestId !== '') {
      axios.cancel(requestId)
    }
    const URL = `${API_BASE_URL_FROZEN}/search/list.js?${stringify({ keyword, type, offset, limit, orderby, mtype })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
      requestId: requestId
    }))
  },
  keywordSearchCustomer ({ limit = '20', offset = '0', orderby = 'score', type = 'all', keyword = '', requestId = '' }) {
    const catchFn = () => {
    }
    const URL = `${API_BASE_URL_FROZEN}/search/customer?${stringify({ keyword, type, offset, limit, orderby })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true,
      requestId: requestId
    }), catchFn)
  },
  getSearchPopularKeywords ({ contentType, offset = 0, limit = 10, mType = 'all' }) {
    const URL = `${API_BASE_URL_FROZEN}/search/popular/keyword/${contentType}?${stringify({ offset, limit, mType })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  },
  getTagsList ({ type, tag, contentid }) {
    const URL = `${API_BASE_URL}/tags/list?${stringify({ type, tag, contentid })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  },
  getRecommendList ({ keyword, offset = 0, limit = 20, mtype = 'all', version = '2', type }) {
    const URL = `${API_BASE_URL_FROZEN}/search/recommend/${type}/list.js?${stringify({ offset, limit, mtype, keyword, version })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true
    }))
  }
}

const MyPooqService = {
  watchHistory ({ offset = 0, limit = 20, orderby = 'new', contenttype = 'vod', image = '' }) {
    const URL = `${API_BASE_URL}/myview/contents?limit=${limit}&offset=${offset}&orderby=${orderby}&contenttype=${contenttype}${image !== '' ? '&image=' + image : ''}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: getDomainWithPrefix(getDomainWithWordPrefix('my', URL)),
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  deleteHistory ({ contenttype = '', contentinfo, updatevalue = 'y' }) {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/myview/contents`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: getDomainWithPrefix(getDomainWithWordPrefix('my', URL)),
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        contenttype,
        contentinfo,
        updatevalue
      }
    }))
  },
  deleteHistoryAll ({ contenttype, updatevalue = 'y' }) {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/myview/contents-all?contenttype=${contenttype}&updatevalue=${updatevalue}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: getDomainWithPrefix(getDomainWithWordPrefix('my', URL)),
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true
    }))
  },
  downloadHistory ({ offset = 0, limit = 20, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/downloads?offset=${offset}&limit=${limit}&orderby=${orderby}&contenttype=all`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  deleteDownloadHistory ({ id = [] }) {
    const URL = `${API_BASE_URL}/downloads`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        id
      }
    }))
  },
  deleteDownloadHistoryAll ({ contenttype = '' }) {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/downloads/user?contenttype=${contenttype}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true
    }))
  },
  zzim ({ offset = 0, limit = 20, contenttype = '' }) {
    const URL = `${API_BASE_URL}/zzim/contents?offset=${offset}&limit=${limit}&contenttype=${contenttype}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  setZzim ({ contentid, contenttype, addalarm }) {
    const URL = `${API_BASE_URL}/zzim/contents/${contentid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        contenttype,
        addalarm
      }
    }))
  },
  deleteZzim ({ contenttype, contentids, delalarm }) {
    const URL = `${API_BASE_URL}/zzim/contents`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        contenttype,
        contentids,
        delalarm
      }
    }))
  },
  postZzimBaseball ({ alarmtype, gameid, contentid, image, contenttitle, channeltitle, releasedatetime }) {
    const URL = `${API_BASE_URL}/dp/baseball/alarms`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        gameid,
        contentid,
        image,
        contenttitle,
        channeltitle,
        releasedatetime
      }
    }))
  },
  deleteZzimBaseball ({ alarmtype, contentid, releasedatetime }) {
    const URL = `${API_BASE_URL}/dp/baseball/alarms`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        contentid,
        releasedatetime
      }
    }))
  },
  alarmList ({ offset = 0, limit = 20, contenttype = '' }) {
    const URL = `${API_BASE_URL}/alarms-contents?offset=${offset}&limit=${limit}&contenttype=${contenttype}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  registAlarm ({ alarmtype, contentid, releasedatetime, programid }) {
    const URL = `${API_BASE_URL}/alarms-contents-regist`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        contentid,
        releasedatetime,
        programid
      }
    }))
  },
  deleteAlarm ({ alarmtype, contentid, releasedatetime }) {
    const URL = `${API_BASE_URL}/alarms-contents`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        alarmtype,
        contentid,
        releasedatetime
      }
    }))
  },
  purchaseProduct ({ startdate = '', enddate = '', producttype = 'pass', autopayment = 'y', offset = 0, limit = 20, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/mypurchase/products?startdate=${startdate}&enddate=${enddate}&producttype=${producttype}&autopayment=${autopayment}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myPurchasePassCancel ({ userserviceid }) {
    const URL = `${API_BASE_URL}/mypurchase/pass/cancel?userserviceid=${userserviceid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myPurchaseContentItem ({ offset = 0, limit = 20, dboption = 'master' }) {
    const URL = `${API_BASE_URL}/mypurchase/contents/item?offset=${offset}&limit=${limit}&dboption=${dboption}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myPurchaseContentPackage ({ offset = 0, limit = 20, dboption = 'master' }) {
    const URL = `${API_BASE_URL}/mypurchase/contents/package?offset=${offset}&limit=${limit}&dboption=${dboption}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myPurchaseContentPackageDetail ({ productid, contenttype, offset, limit }) {
    const URL = `${API_BASE_URL}/purchase/product-contents/${productid}?contenttype=${contenttype}&offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  deleteMyPurchaseContentItem ({ paymentId = [] }) {
    const URL = `${API_BASE_URL}/mypurchase/contents`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: { paymentId }
    }))
  },
  deleteMyPurchaseContentAll () {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/mypurchase/contents/allitem`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true
    }))
  },
  deleteMyPurchasePackageAll () {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/mypurchase/contents/allpackage`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getPassPromotion ({ packagemasterid }, catchFn) {
    const URL = `${API_BASE_URL}/mypurchase/pass/promotion?packagemasterid=${packagemasterid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }), catchFn)
  },
  passPromotionCancel ({ productType, keyId, status }, catchFn) {
    const URL = `${API_BASE_URL}/mypurchase/pass/cancel`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        productType,
        keyId,
        status
      }
    }), catchFn)
  },
  myPurchasePassEvent ({ eventType }, catchFn) {
    const URL = `${API_BASE_URL}/mypurchase/pass/event`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: {
        eventType
      }
    }), catchFn)
  },
  myPurchasePassPromotionContinue ({ packagemasterid }, catchFn) {
    const URL = `${API_BASE_URL}/mypurchase/pass/promotion/continue?packagemasterid=${packagemasterid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }), catchFn)
  },
  getMyCoinSummary () {
    const URL = `${API_BASE_URL}/mycoin/summary`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getMyCoinListCharged ({ offset, limit, orderby }) {
    const URL = `${API_BASE_URL}/mycoin/list/charged?offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getMyCoinListExpired ({ offset, limit, orderby }) {
    const URL = `${API_BASE_URL}/mycoin/list/expired?offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getMyCouponList ({ coupontype, status, offset, limit, orderby }) {
    const URL = `${API_BASE_URL}/mycoupons/list?coupontype=${coupontype}&status=${status}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myCouponActivate ({ couponnumber }) {
    const URL = `${API_BASE_URL}/mycoupons/activate/${couponnumber}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true
    }))
  },
  myCouponRegister ({ couponnumber }) {
    const URL = `${API_BASE_URL}/mycoupons/register/${couponnumber}`
    return apiRequestWithoutCatchFn(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true
    }))
  },
  userQna ({ offset = 0, limit = 20, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/user/qna?offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  deleteQna ({ qnaid }) {
    const URL = `${API_BASE_URL}/user/qna`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        qnaid
      }
    }))
  },
  getAlarms ({ offset, limit }) {
    const URL = `${API_BASE_URL}/alarms?offset=${offset}&limit=${limit}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  markReadAllAlarms () {
    const URL = `${API_BASE_URL}/alarms`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getAlarmsReceiver () {
    const URL = `${API_BASE_URL}/alarms-receiver`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  setAlarmsReceiver ({ live, upload, movie, coupon, coin, event, myview, popular }) {
    const URL = `${API_BASE_URL}/alarms-receiver`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_POST,
      needCommonParams: true,
      needCredential: true,
      data: { live, upload, movie, coupon, coin, event, myview, popular }
    }))
  },
  deleteAllAlarms ({ status }) {
    const URL = `${API_BASE_URL}/alarms`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_DELETE,
      needCommonParams: true,
      needCredential: true,
      data: {
        status
      }
    }))
  }
}

const CustomerService = {
  getRecommendFaqList () {
    const URL = `${API_BASE_URL}/faqsrecommend`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getFaqFilters ({ type = 'faqcategory' }) {
    const URL = `${API_BASE_URL}/filters?type=${type}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getFaqList ({ type = 'all', faqid = '', offset = 0, limit = 10, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/faqs?type=${type}&faqid=${faqid}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getFaqDetail ({ faqid }) {
    const URL = `${API_BASE_URL}/faqs/${faqid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  searchFaqList ({ type = '', keyword = '', offset = 0, limit = 10, orderby = 'new' }) {
    const URL = `${API_BASE_URL_FROZEN}/search/faq?${stringify({ keyword, type, offset, limit, orderby })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getNoticeList ({ type = 'all', top, offset = 0, limit = 10, orderby = 'new' }) {
    const URL = `${API_BASE_URL}/notices?type=${type}&top=${top}&offset=${offset}&limit=${limit}&orderby=${orderby}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getSearchNotice ({ type = 'all', keyword, offset = 0, limit = 10, orderby = 'new' }) {
    const URL = `${API_BASE_URL_FROZEN}/search/notices?${stringify({ keyword, type, offset, limit, orderby })}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getNoticeDetail ({ noticeid }) {
    const URL = `${API_BASE_URL}/notices/${noticeid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const VoucherService = {
  getVoucherPurchase ({ store = 'wavve', device = 'mobile' }) {
    if (store === '' && device === DEVICE_TYPE_ANDROID) {
      store = 'wavve'
      device = DEVICE_TYPE_MOBILE
    }
    const URL = `${API_BASE_URL}/passes/service/${store}/${device}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getPromotionVoucherList () {
    const URL = 'https://pooq3-static-json.wavve.com/service/marketing/passevent.json'
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getBannerImage ({ bannerId }) {
    const URL = `${API_BASE_URL}/cf/uiservice/banner/single/${bannerId}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getPromotionInfo () {
    const timeStamp = new Date().getTime()
    const URL = 'https://pooq3-static-json.wavve.com/service/marketing/promotioninfo.json?timeStamp=' + timeStamp
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getVoucherPromotion ({ url }) {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: url,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  PromotionBanner ({ url }) {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: url,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  },
  getPlayyOnlyVoucherList () {
    const URL = 'https://pooq3-static-json.wavve.com/service/passlist/purchase-products-recommend-ios_201911.json'
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const AgreementService = {
  getTerms ({ type, version }) {
    const URL = `${API_BASE_URL}/terms?type=${type}&version=${version}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const FooterNoticeSerivce = {
  getNotices () { // all, service, contents 기존로직이 타잎은 받지만 호출할때 안씀
    const URL = `${API_BASE_URL}/uiservice/notices`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const NoticePopupService = {
  getNoticeBanner ({ bannerid }) {
    const URL = `${API_BASE_URL}/uiservice/banner/multi/${bannerid}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const ZzimService = {
  getZzimStatus ({ contentid, contenttype }) {
    const URL = `${API_BASE_URL}/zzim/contents/${contentid}?contenttype=${contenttype}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }))
  }
}
// event 처리
const ShortcutService = {
  getFullUrlByPincode ({ pincode, target = 'aws' }) {
    const URL = `${API_BASE_URL_CLOVER_FIELD}/shorturl/${pincode}`
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: URL,
      method: HTTP_METHOD_GET,
      needCommonParams: true,
      needCredential: true
    }), () => {})
  }
}

const AnalizeService = {
  sendLogList (onDisplayEventList) {
    const eventInfo = first(onDisplayEventList)
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: 'https://' + get(eventInfo, 'url'),
      method: get(eventInfo, 'method'),
      data: {
        list: onDisplayEventList.map(eventBodyListParser)
      },
      needCommonParams: true,
      needCredential: true
    }))
  }
}

const PartnersService = {
  getList () {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/partner/list`,
      method: HTTP_METHOD_GET
    }))
  },
  regist ({ groupcode, membercode, email }) {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/partner/regist`,
      method: HTTP_METHOD_POST,
      needCredential: true,
      data: {
        groupcode,
        membercode,
        email
      }
    }))
  },
  authenticate ({ email, authenticatecode }) {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/partner/authenticate`,
      method: HTTP_METHOD_POST,
      needCredential: true,
      data: {
        email,
        authenticatecode
      }
    }))
  },
  checkAlreadyRegisted (credentail) {
    return apiRequest(commonRequestInstanceToAxiosRequestInfo({
      url: `${API_BASE_URL}/partner/checkuser?credential=${credentail}`,
      method: HTTP_METHOD_GET
    }))
  }
}

function getAdultVerificationStatus () {
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: `${API_BASE_URL}/user/pin/adult`,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }), (error) => { commonErrorProcess(error); location.href = '/' })
}

function changeAdultContentProtectionState (pincode, settings, errorCallback) {
  console.log('pincode: ' + pincode)
  console.log('settings: ' + settings)
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: `${API_BASE_URL}/user/pin/adult/confirm`,
    method: HTTP_METHOD_POST,
    data: {
      pincode,
      settings
    },
    needCommonParams: true,
    needCredential: true
  }), errorCallback)
}

function verifyAdultContentProtectionState (pincode, errorCallback) {
  console.log('pincode: ' + pincode)
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: `${API_BASE_URL}/user/pin/adult/confirm`,
    method: HTTP_METHOD_POST,
    data: {
      pincode
    },
    needCommonParams: true,
    needCredential: true
  }), errorCallback)
}

function changeAdultContentProtectionStateForOTT (pincode, settings, errorCallback) {
  console.log('OTT pincode: ' + pincode)
  console.log('OTT settings: ' + settings)
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: `${API_BASE_URL}/user/pin/adult/ott`,
    method: HTTP_METHOD_POST,
    data: {
      pincode,
      settings
    },
    needCommonParams: true,
    needCredential: true
  }), errorCallback)
}

function getServiceLocation (credential) {
  const timeStamp = new Date().getTime()
  return axios.get(`${API_BASE_URL}/getservicelocation?credential=${credential}&timestamp=${timeStamp}`,
    {
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
}

function knock () {
  const URL = `${API_BASE_URL}/knock`
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }))
}

function getCoverMetaData () {
  const URL = `https://pooq3-static-json.wavve.com/service/marketing/coverpage.json`
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }))
}

function postPromotionUser ({ promotionId, productType, keyId }) {
  const URL = `${API_BASE_URL}/promotion/user/${promotionId}`
  return apiRequestWithoutCatchFn(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_POST,
    needCommonParams: true,
    needCredential: true,
    data: {
      productType,
      keyId
    }
  }))
}
function getSaltedHash (credential) {
  const URL = `${API_BASE_URL}/user/hash?credential=${credential}`
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }))
}
function getGuidIssue () {
  const URL = `${API_BASE_URL}/guid/issue`
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }))
}
function getIp () {
  const URL = `${API_BASE_URL}/ip`
  return apiRequest(commonRequestInstanceToAxiosRequestInfo({
    url: URL,
    method: HTTP_METHOD_GET,
    needCommonParams: true,
    needCredential: true
  }))
}

export {
  commonErrorProcess,
  QASerive,
  NoticePopupService,
  GNBService,
  AnalizeService,
  CommonService,
  EventService,
  MovieInfoService,
  VodInfoService,
  LiveInfoService,
  ClipInfoService,
  DeepLinkService,
  BottomTabService,
  UserService,
  SearchService,
  MyPooqService,
  CustomerService,
  VoucherService,
  AgreementService,
  FooterNoticeSerivce,
  ShortcutService,
  ZzimService,
  PartnersService,
  getServiceLocation,
  getAdultVerificationStatus,
  changeAdultContentProtectionState,
  verifyAdultContentProtectionState,
  changeAdultContentProtectionStateForOTT,
  getCoverMetaData,
  knock,
  postPromotionUser,
  getSaltedHash,
  getGuidIssue,
  getIp
}
